(() => {
  // Vitabu: keep customer on product page after Add to cart; prevent duplicate book; refresh header count the theme's own way.
  const IN_CART_LABEL = 'In cart · View cart';

  function cartUrl() {
    return (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
  }
  function addUrl() {
    return (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
  }

  // Replace the header badge using the section HTML returned by the add mutation (post-add state).
  function updateCountFromSections(sections) {
    try {
      const html = sections && sections['cart-icon-bubble'];
      if (!html) return false;
      const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (fresh && target) {
        target.innerHTML = fresh.innerHTML;
        return true;
      }
      // Fallback: copy just the count text across by class.
      const freshCount = new DOMParser().parseFromString(html, 'text/html').querySelector('.wbhcartitem');
      if (freshCount) {
        document.querySelectorAll('.wbhcartitem').forEach((el) => { el.textContent = freshCount.textContent; });
        return true;
      }
    } catch (e) { /* non-fatal */ }
    return false;
  }

  function getBtn(form) {
    return form.querySelector('.product-form__submit') || form.querySelector('button[name="add"]');
  }

  function setButtonInCart(form) {
    const btn = getBtn(form);
    if (!btn) return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('vitabu-in-cart');
    const span = btn.querySelector('span') || btn;
    span.textContent = IN_CART_LABEL;
    btn.dataset.vitabuInCart = '1';
  }

  function showAddedFlag(form) {
    const host = (getBtn(form) && (getBtn(form).closest('.product-form') || form)) || form;
    let flag = host.parentNode.querySelector('.vitabu-added-flag');
    if (!flag) {
      flag = document.createElement('p');
      flag.className = 'vitabu-added-flag';
      flag.innerHTML = 'Added ✓ · <a href="' + cartUrl() + '">View cart</a>';
      host.insertAdjacentElement('afterend', flag);
    }
    flag.style.display = '';
  }

  function takeOver(productForm) {
    if (!productForm || productForm.dataset.vitabuTakeover === '1') return;
    productForm.dataset.vitabuTakeover = '1';
    const form = productForm.querySelector('form');
    if (!form) return;
    const btn = getBtn(form);
    const idInput = form.querySelector('[name="id"]');

    // Click on an in-cart button → go to cart, never add again (capture phase beats theme handler).
    if (btn) {
      btn.addEventListener('click', (e) => {
        if (btn.dataset.vitabuInCart === '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location = cartUrl();
        }
      }, true);
    }

    form.addEventListener('submit', async (e) => {
      if (btn && btn.dataset.vitabuInCart === '1') { e.preventDefault(); e.stopImmediatePropagation(); window.location = cartUrl(); return; }
      e.preventDefault();
      e.stopImmediatePropagation(); // prevent product-form.js handler + its /cart redirect
      if (!idInput || !idInput.value) { form.submit(); return; }
      if (btn) btn.setAttribute('aria-busy', 'true');
      try {
        const body = new FormData();
        body.append('id', idInput.value);
        body.append('quantity', '1');
        // Ask for the refreshed cart-icon-bubble section IN the add response (theme's own approach):
        body.append('sections', 'cart-icon-bubble');
        body.append('sections_url', window.location.pathname);
        const res = await fetch(addUrl(), {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body
        });
        if (btn) btn.removeAttribute('aria-busy');
        if (!res.ok) return; // on failure, leave as-is, no redirect
        const data = await res.json();
        updateCountFromSections(data && data.sections);
        showAddedFlag(form);
        setButtonInCart(form);
        if (btn) btn.dataset.vitabuInCart = '1';
      } catch (err) {
        if (btn) btn.removeAttribute('aria-busy');
        form.submit(); // unexpected error → fall back to theme's normal navigation
      }
    }, true);
  }

  function init() {
    document.querySelectorAll('product-form').forEach((pf) => {
      takeOver(pf);
      if (pf.dataset.vitabuInitInCart === '1') {
        const form = pf.querySelector('form');
        if (form) { setButtonInCart(form); }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
